var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99968 3.3335C9.77866 3.3335 9.5667 3.42129 9.41042 3.57757C9.25414 3.73386 9.16634 3.94582 9.16634 4.16683C9.16634 4.38784 9.25414 4.59981 9.41042 4.75609C9.5667 4.91237 9.77866 5.00016 9.99968 5.00016C10.2207 5.00016 10.4327 4.91237 10.5889 4.75609C10.7452 4.59981 10.833 4.38784 10.833 4.16683C10.833 3.94582 10.7452 3.73386 10.5889 3.57757C10.4327 3.42129 10.2207 3.3335 9.99968 3.3335ZM9.99968 9.16683C9.77866 9.16683 9.5667 9.25463 9.41042 9.41091C9.25414 9.56719 9.16634 9.77915 9.16634 10.0002C9.16634 10.2212 9.25414 10.4331 9.41042 10.5894C9.5667 10.7457 9.77866 10.8335 9.99967 10.8335C10.2207 10.8335 10.4327 10.7457 10.5889 10.5894C10.7452 10.4331 10.833 10.2212 10.833 10.0002C10.833 9.77915 10.7452 9.56719 10.5889 9.41091C10.4327 9.25463 10.2207 9.16683 9.99968 9.16683ZM9.99967 15.0002C9.77866 15.0002 9.5667 15.088 9.41042 15.2442C9.25414 15.4005 9.16634 15.6125 9.16634 15.8335C9.16634 16.0545 9.25414 16.2665 9.41042 16.4228C9.5667 16.579 9.77866 16.6668 9.99967 16.6668C10.2207 16.6668 10.4326 16.579 10.5889 16.4228C10.7452 16.2665 10.833 16.0545 10.833 15.8335C10.833 15.6125 10.7452 15.4005 10.5889 15.2442C10.4327 15.088 10.2207 15.0002 9.99967 15.0002Z",
    stroke: "#949494",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/three-dots-icon.78c2b4ea7916a635565b1b98c0975ffb.svg";
export { ForwardRef as ReactComponent };